import React from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/svg/group77.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { AppDataContext } from '../../../contexts/app-data';

const ProIntro = () => {
    const { state, dispatch } = React.useContext(AppDataContext)

    const lang = localStorage.getItem('language')

         React.useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "3",
stepName: "pro info:almost there",
eventAction: "stepStart",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }

     }, [])

    return (
        <div className={"intro-step"}>
            <StepsWrapper stepGroupTitle={t('pro_infos.title')} loaded={0.1} title={t('general.open_pro_account')}>
                <StepsLoader>

                    <BaseParagraph  illustration={illustration} />
                    <BaseParagraph  align={"center"} >
                        <h3>{ t('pro_infos.pro_info_almost_there.title')}</h3>
                        <p>{ t('pro_infos.pro_info_almost_there.text')}</p>
                    </BaseParagraph>

                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} link={`/${lang.toLowerCase()}/pro-steps/has-enterprise`} />
                    </div>
                </StepsLoader>
            </StepsWrapper>
        </div>

    )
}

ProIntro.propTypes = {
    name: PropTypes.string
}

ProIntro.defaultProps = {
    name: "Step02"
}


export default ProIntro